export const thanksgivingPromo = {
  id: 'thanksgiving-2026',
  occasion: 'Thanksgiving special',
  headline: 'Free Deco Seal around your pool perimeter',
  condition: 'with any plaster job',
  deadlineLabel: 'Ends November 30',
  messageLine: 'Promo: Thanksgiving special — free Deco Seal around the pool perimeter with a plaster job',
  // Last moment the promo is shown (end of Nov 30, Houston time).
  endsAt: new Date('2026-11-30T23:59:59-06:00'),
}

export function isPromoActive(now: Date = new Date()) {
  return now.getTime() <= thanksgivingPromo.endsAt.getTime()
}
